export default __webpack_public_path__ + "static/media/56t.2f5b6a20.jpg";